// @flow

import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { HashLink as Link } from 'react-router-hash-link'
import { withRouter } from 'react-router-dom'
import { translate } from '../../helpers/global'
import { UilAngleRightB } from '@iconscout/react-unicons'
import imgDropHeader from '../../images/img-drop-header.jpg'
import { fetchArticlesData } from '../../actions/learn'

type Props = {
  globalGetLanguages: string,
  articlesData: any,
  articlesDataError: boolean,
  fetchArticlesData: () => void,
  history: any,
  closeDropdown?: () => void
}

const DropdownTalentAcq = ({ globalGetLanguages, articlesData, articlesDataError, fetchArticlesData, history, closeDropdown }: Props) => {
  const [activeSection, setActiveSection] = useState('platform')
  const [apiData, setApiData] = useState({
    ta_astrnt: null,
    ta_solution: null
  })

  // Fetch API data on component mount
  useEffect(() => {
    fetchArticlesData()
  }, [fetchArticlesData])

  // Update local state when Redux data changes
  useEffect(() => {
    if (articlesData && articlesData.size > 0) {
      const articlesDataJS = articlesData.toJS()
      setApiData({
        ta_astrnt: articlesDataJS.ta_astrnt || null,
        ta_solution: articlesDataJS.ta_solution || null
      })
    }
  }, [articlesData])

  // Get current content based on active section
  const getCurrentContent = () => {
    return activeSection === 'platform' ? apiData.ta_astrnt : apiData.ta_solution
  }

  // Update API content when active section changes
  useEffect(() => {
    // Remove debug logs
  }, [activeSection, apiData])

  // Define content for each section
  const contentSections = {
    platform: {
      leftColumn: {
        title: 'End-to-End Hiring Platform',
        links: [
          { to: '/talent-acquisition/astrnt-platform/astrnt-recommends', text: 'ASTRNT Recommends' },
          { to: '/talent-acquisition/astrnt-platform/ai-structured-video-interview', text: 'AI Interview' },
          { to: '/talent-acquisition/astrnt-platform/ai-structured-video-interview', text: 'Structured Video Interview' }
        ]
      },
      rightColumn: {
        title: '',
        links: [
          { to: '/talent-acquisition/skill-validation', text: 'Skill Validation' },
          { to: '/talent-acquisition/skill-validation', text: 'Assessments' },
          { to: '/apis', text: 'APIs' }
        ]
      }
    },
    solutions: {
      leftColumn: {
        title: null, // No title for solutions
        links: [
          { to: '/nextgen-assessment-center?utm_content=talent-acquisition', text: 'NextGen Assessment Center' },
          { to: '/nextgen-rpo', text: 'NextGen RPO' },
        ]
      },
      rightColumn: {
        title: null, // No title for solutions
        links: [
          { to: '/talent-acquisition/graduate', text: 'Graduate' },
          { to: '/talent-acquisition/professional', text: 'Professional' },
          { to: '/talent-acquisition/technical', text: 'Technical' },
          { to: '/talent-acquisition/hourly', text: 'Hourly' }

        ]
      }
    }
  }

  const currentContent = contentSections[activeSection]
  const currentApiContent = getCurrentContent()

  return (
        <section>
          <li className="head-drop-page-link">
            <a 
              className={activeSection === 'platform' ? 'active' : ''}
              onMouseEnter={() => {
                setActiveSection('platform')
              }}
              onClick={() => setActiveSection('platform')}
            >
              ASTRNT Platform <UilAngleRightB/>
            </a>
            <a 
              className={activeSection === 'solutions' ? 'active' : ''}
              onMouseEnter={() => {
                setActiveSection('solutions')
              }}
              onClick={() => setActiveSection('solutions')}
            >
              Solutions & Use Cases <UilAngleRightB/>
            </a>
          </li>
          <li className="link-middle">
            {currentContent.leftColumn.title && <h2>{currentContent.leftColumn.title}</h2>}
            {currentContent.leftColumn.links.map((link, index) => (
              <Link key={index} to={link.to}>{link.text}</Link>
            ))}
          </li>
          <li className="link-middle">
            {currentContent.rightColumn.title ? 
              <h2>{currentContent.rightColumn.title}</h2> : 
              (activeSection === 'platform' ? <h2>&nbsp;</h2> : null)
            }
            {currentContent.rightColumn.links.map((link, index) => (
              <Link key={index} to={link.to}>{link.text}</Link>
            ))}
          </li>
          {getCurrentContent() && (
            <li className="link-with-img" onClick={() => {
              history.push(`/learn-detail/${currentApiContent.id}`)
              if (closeDropdown) closeDropdown()
            }}>
              <img src={currentApiContent.image_url} alt={currentApiContent.title} />
              <h4>{currentApiContent.title}</h4>
              <p>{currentApiContent.desc}</p>
            </li>
          )}
        </section>
  )
}

const mapStateToProps = (state) => ({
  articlesData: state.articlesData,
  articlesDataError: state.articlesDataError
})

const mapDispatchToProps = {
  fetchArticlesData
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DropdownTalentAcq))